<template>
  <div>
    <div class="MerchantsDaybox">
      <div class="icon_box">
        <img :src="$OSSBaseUrl+'CouponPageBannerImg.png'" alt="" />
      </div>
      <NoticeBar 
        class="banner"
        color="#000"
        background="#C4DFFF"
        :scrollable="false"
        >
        <Swipe
          vertical
          class="notice-swipe"
          :autoplay="2000"
          :show-indicators="false"
          :touchable='false'
        >
          <SwipeItem v-for='(item, index) in order_record' :key='index'>{{item}}</SwipeItem>
        </Swipe>
      </NoticeBar>
    </div>
    <!-- 信息详情页banner -->
    <div
      @click="jump_link"
      v-if="$route.name == 'CustomerInfo'"
      class="MerchantsDay_banner_box"
    >
      <div class="BannerTips">{{BannerTips}}</div>
      <img
        class="MerchantsDay_banner"
        :src="$OSSBaseUrl + BannerImage"
      />
    </div>
  </div>
</template>
<script>
import { NoticeBar, Swipe, SwipeItem } from "vant";
import { URL5,URL6 } from "@/utils/Redirect";
import { mapState } from "vuex";

export default {
  name: "CouponPageBanner",
  components: {
    NoticeBar,
    Swipe, 
    SwipeItem
  },
  props: {
    order_record: Array
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      UserInfo: (state) => {
        return state.Public.UserInfo;
      },
    }),
  },
  mounted(){
  },
  
  methods: {
    jump_link() {
      let data = {
        page_from: "main_page",
        page_name: this.$route.name,
        page_time: "0.00",
        btn_name: "立即续费",
        receiver_id: "",
        page_param: { btn_name: "renew_button" },
      };
      this.$store.dispatch("Public/inH5Record", data).then(res=>{
        window.location.href=this.Link
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>